import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from 'moment-jalaali';
import { listLoggerEmail } from '../../modules/Api';
import history from '../../modules/History';

class LoggerSubscribers extends Component
{
    constructor() {
        super();
        this.state = {
            items: [],
            stores: [],
            store: '',
            time: '',
            email: '',
            status: 1,
            visibleModal: false,
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }


    render() {
        let ROLE = null;

        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        if(userInfo) {
            ROLE = userInfo.role;
        }
        let columns;
        if(ROLE === 'STAFF') {
            columns = [
                {
                    Header: 'آیدی',
                    accessor: 'id',
                    style:{textAlign:'center'}
                },
                {
                    Header: 'عنوان',
                    accessor: 'title',
                    filterable: true,
                    sortable: false,
                    Cell: (row) => (<span title={row.original.data != null ? row.original.data.title : ''}> {row.original.data != null ? row.original.data.title : ''} </span>),
                    style:{textAlign:'center'}
                },
                {
                    Header: 'تاریخ ارسال',
                    accessor: 'created_at',
                    Cell: (row) => (<span style={{direction: 'rtl'}}>{moment(row.original.created_at).format('jYYYY-jMM-jDD HH:mm:ss')}</span>),
                    style:{textAlign:'center'}
                }
            ]
        }else {
            columns = [
                {
                    Header: 'آیدی',
                    accessor: 'id',
                    style:{textAlign:'center'}
                },
                {
                    Header: 'عنوان',
                    accessor: 'title',
                    filterable: true,
                    sortable: false,
                    Cell: (row) => (<span title={row.original.data != null ? row.original.data.title : ''}> {row.original.data != null ? row.original.data.title : ''} </span>),
                    style:{textAlign:'center'}
                },
                {
                    Header: 'تاریخ ارسال',
                    accessor: 'created_at',
                    Cell: (row) => (<span style={{direction: 'rtl'}}>{moment(row.original.created_at).format('jYYYY-jMM-jDD HH:mm:ss')}</span>),
                    style:{textAlign:'center'}
                },
                {
                    Header: 'مشاهده جزئیات',
                    accessor: 'show',
                    Cell: (row) => <span style={{backgroundColor: '#0066ff', color: '#fff', borderRadius: '4px', padding: '8px', cursor: 'pointer'}} onClick={() => {window.open(`/logger/newsletters/${row.original.id}`, "_blank")}}>مشاهده جزئیات</span>,
                    style:{textAlign:'center'}
                }
            ]
        }
        
        return (
            <ReactTable
                    data={this.state.items}
                    columns={columns}
                    onFetchData={state => this.onChange(state)}
                    manual
                    defaultPageSize={15}
                    pages={this.state.last_page}/>
        );
    }

    fetchData = (query) => {
        listLoggerEmail(query, (data) => {this.setState({
            items: data.data,
            count: data.total,
            last_page: data.last_page,
            pageSize: data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'id',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc', 
                field: state.sorted[0].id,
            }
        }

        const filter = {
            store: state.filtered.find(f => f.id === 'store') ? state.filtered.find(f => f.id === 'store').value : '',
            time: state.filtered.find(f => f.id === 'time') ? state.filtered.find(f => f.id === 'time').value : '',
            email: state.filtered.find(f => f.id === 'email') ? state.filtered.find(f => f.id === 'email').value : '',
            status: state.filtered.find(f => f.id === 'status') ? state.filtered.find(f => f.id === 'status').value : '',
        };
        
        const query = `page=${state.page  + 1}&perPage=${state.pageSize}&filter=${JSON.stringify(filter)}&sort=${JSON.stringify(sort)}`;
        
        this.fetchData(query);
    }
}

export default LoggerSubscribers;


// WEBPACK FOOTER //
// ./src/containers/LoggerSubscribers/index.js